module.exports = __webpack_public_path__ + "img/card1.9950d1f9.png";